import type { SVGProps } from 'react';

const InactiveProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={212} height={211} viewBox="0 0 212 211" fill="none" {...props}>
    <g clipPath="url(#clip0_34_455)">
      <mask
        id="mask0_34_455"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={212}
        height={211}
      >
        <path d="M0 0H212V211H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_34_455)">
        <mask
          id="mask1_34_455"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={212}
          height={211}
        >
          <path d="M0 0H212V211H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask1_34_455)">
          <path
            d="M106.5 202C159.795 202 203 158.795 203 105.5C203 52.2045 159.795 9 106.5 9C53.2045 9 10 52.2045 10 105.5C10 158.795 53.2045 202 106.5 202Z"
            fill="#F1F7F8"
          />
          <path
            d="M107.999 49.001H106.999C76.0711 49.001 50.999 74.073 50.999 105.001C50.999 135.929 76.0711 161.001 106.999 161.001H107.999C138.927 161.001 163.999 135.929 163.999 105.001C163.999 74.073 138.927 49.001 107.999 49.001Z"
            fill="white"
          />
          <path
            d="M107.999 50.001H106.999C76.6233 50.001 51.999 74.6253 51.999 105.001C51.999 135.377 76.6233 160.001 106.999 160.001H107.999C138.375 160.001 162.999 135.377 162.999 105.001C162.999 74.6253 138.375 50.001 107.999 50.001Z"
            stroke="#043863"
            strokeWidth={2}
          />
          <mask
            id="mask2_34_455"
            style={{
              maskType: 'luminance',
            }}
            maskUnits="userSpaceOnUse"
            x={51}
            y={50}
            width={112}
            height={110}
          >
            <path
              d="M107.999 50H106.999C76.6233 50 51.999 74.6243 51.999 105C51.999 135.376 76.6233 160 106.999 160H107.999C138.375 160 162.999 135.376 162.999 105C162.999 74.6243 138.375 50 107.999 50Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_34_455)">
            <path
              d="M99.6028 165.49H84.9978V122.43L72.5688 131.91L81.3688 142.886C82.8801 144.391 83.7348 146.434 83.7465 148.567C83.7582 150.7 82.926 152.751 81.4313 154.273C79.9366 155.795 77.9007 156.664 75.7677 156.691C73.6346 156.718 71.5774 155.901 70.0448 154.417L57.4458 134.67C56.6146 133.853 55.9698 132.867 55.5556 131.777C55.1414 130.688 54.9676 129.522 55.0462 128.36C55.1247 127.197 55.4537 126.065 56.0107 125.042C56.5676 124.018 57.3393 123.127 58.2728 122.43L79.9908 102.448C80.9798 101.706 82.1265 101.203 83.3418 100.977C83.3556 100.953 83.3752 100.932 83.3987 100.917C83.4222 100.902 83.449 100.893 83.4768 100.891H83.9198C84.5198 100.824 90.5738 100.518 91.1698 100.585L107.26 100.794L123.348 100.587C123.948 100.52 129.998 100.826 130.598 100.893H131.041C131.069 100.895 131.096 100.904 131.119 100.918C131.143 100.933 131.163 100.953 131.177 100.977C132.392 101.203 133.539 101.707 134.528 102.448L156.245 122.43C157.179 123.127 157.95 124.018 158.507 125.042C159.064 126.065 159.393 127.197 159.472 128.36C159.55 129.522 159.376 130.688 158.962 131.777C158.548 132.867 157.903 133.853 157.072 134.67L144.475 154.417C143.718 155.161 142.822 155.748 141.838 156.145C140.853 156.543 139.801 156.742 138.74 156.733C137.678 156.723 136.629 156.505 135.653 156.09C134.676 155.675 133.79 155.072 133.047 154.314C132.303 153.557 131.716 152.661 131.318 151.677C130.921 150.693 130.721 149.64 130.731 148.579C130.74 147.518 130.959 146.469 131.374 145.492C131.789 144.515 132.392 143.63 133.149 142.886L141.949 131.91L129.52 122.43V165.49H99.6028Z"
              fill="#D3E5E7"
              stroke="#054B54"
              strokeWidth={2}
            />
            <path
              d="M79.5 160.001C84.7467 160.001 89 155.748 89 150.501C89 145.254 84.7467 141.001 79.5 141.001C74.2533 141.001 70 145.254 70 150.501C70 155.748 74.2533 160.001 79.5 160.001Z"
              fill="white"
            />
            <path
              d="M79.5 159.001C84.1944 159.001 88 155.195 88 150.501C88 145.807 84.1944 142.001 79.5 142.001C74.8056 142.001 71 145.807 71 150.501C71 155.195 74.8056 159.001 79.5 159.001Z"
              stroke="#054B54"
              strokeWidth={2}
            />
            <path
              d="M135.936 160.275C141.332 160.275 145.706 155.901 145.706 150.505C145.706 145.109 141.332 140.735 135.936 140.735C130.54 140.735 126.166 145.109 126.166 150.505C126.166 155.901 130.54 160.275 135.936 160.275Z"
              fill="white"
            />
            <path
              d="M135.936 159.275C140.78 159.275 144.706 155.349 144.706 150.505C144.706 145.661 140.78 141.735 135.936 141.735C131.092 141.735 127.166 145.661 127.166 150.505C127.166 155.349 131.092 159.275 135.936 159.275Z"
              stroke="#054B54"
              strokeWidth={2}
            />
          </g>
          <path
            d="M108.5 94.002C118.717 94.002 127 85.7192 127 75.502C127 65.2847 118.717 57.002 108.5 57.002C98.2827 57.002 90 65.2847 90 75.502C90 85.7192 98.2827 94.002 108.5 94.002Z"
            fill="white"
          />
          <path
            d="M108.5 93.002C118.165 93.002 126 85.1669 126 75.502C126 65.837 118.165 58.002 108.5 58.002C98.835 58.002 91 65.837 91 75.502C91 85.1669 98.835 93.002 108.5 93.002Z"
            stroke="#054B54"
            strokeWidth={2}
          />
          <path
            d="M112.503 80.886C112.503 81.9854 112.066 83.0399 111.289 83.8173C110.511 84.5947 109.457 85.0315 108.357 85.0315C107.258 85.0315 106.204 84.5947 105.426 83.8173C104.649 83.0399 104.212 81.9854 104.212 80.886"
            stroke="#054B54"
            strokeWidth={2}
            strokeMiterlimit={10}
          />
          <path
            d="M100.39 59.7922C100.39 59.7922 107.556 74.4369 123.105 66.6809C122.095 62.9109 118.527 58.3685 107.791 58.4055C105.301 58.7371 102.831 59.2004 100.39 59.7922Z"
            fill="#054B54"
          />
          <path
            d="M101.062 60.4528C101.062 60.4528 101.681 69.8922 92.2617 69.8922C93.5825 67.0671 95.3004 64.4448 97.3623 62.1051L101.062 60.4528Z"
            fill="#054B54"
          />
          <path
            d="M107.999 50.001H106.999C76.6233 50.001 51.999 74.6253 51.999 105.001C51.999 135.377 76.6233 160.001 106.999 160.001H107.999C138.375 160.001 162.999 135.377 162.999 105.001C162.999 74.6253 138.375 50.001 107.999 50.001Z"
            stroke="#054B54"
            strokeWidth={2}
          />
          <path
            d="M150.5 82C160.165 82 168 74.3888 168 65C168 55.6112 160.165 48 150.5 48C140.835 48 133 55.6112 133 65C133 74.3888 140.835 82 150.5 82Z"
            fill="#F64928"
          />
          <path d="M114.002 109.822H127.676" stroke="white" strokeWidth={4} />
        </g>
      </g>
      <path
        d="M153.176 56H157L153.177 59.8H157M149.667 63.6H153.741L149.667 67.4H153.741M146 71.2H150.074L146 75H150.074"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_34_455">
        <rect width={212} height={211} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default InactiveProfile;
